/**
 * API Configuration utility
 * Automatically detects if running on localhost or network IP
 */
const getApiBaseUrl = (includeApiPath: boolean = true): string => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = '8000';
  const apiPath = includeApiPath ? '/api' : '';

  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    return `${protocol}//${hostname}:${port}${apiPath}`;
  }

  return `http://localhost:${port}${apiPath}`;
};

export const API_BASE_URL = getApiBaseUrl(true);
export const API_BASE_URL_NO_API = getApiBaseUrl(false);
